export interface UserOffices {
  OfficeId: string;
  Name: string;
  Address: Address;
  PhoneNumber: string;
  EmailAddress: string;
  AltaId: string;
  FirmLicense: string;
}

export interface Address {
  Address1: string;
  Address2: string;
  City: string;
  PostalCode: string;
  State: string;
  County: string;
}

export interface BopsOptions {
  id: number;
  name: string;
}

export interface UserAccessKeyOptions {
  ThirdPartyVendorId: number;
  vendorName: string;
}

export const bopsOptions: BopsOptions[] = [
  { id: 3317, name: 'AgentNet Standard XML' },
  { id: 3301, name: 'AIM' },
  { id: 3302, name: 'AccuTitle' },
  { id: 3304, name: 'DisplaySoft' },
  { id: 3305, name: 'DoubleTime' },
  { id: 3306, name: 'Landtech Manual Import' },
  { id: 3307, name: 'RamQuest XML' },
  { id: 3308, name: 'RamQuest Order Entry' },
  { id: 3309, name: 'SoftPro PXT' },
  { id: 3312, name: 'Title Express' },
  { id: 3315, name: 'Manual Import XML' },
  { id: 3316, name: 'zzSoftPro PXT' },
  { id: 3330, name: 'FL ALTA Loan Policy' },
  { id: 3331, name: 'FL ALTA Owner Policy' },
  { id: 3332, name: 'TitleSoft PXT' },
  { id: 3333, name: 'Qualia JSON' },
  { id: 3334, name: 'SnapClose XML' },
  { id: 3335, name: 'Cover Sheet' },
  { id: 3350, name: 'FA Standard XML' },
];

export const sortedBopsoptions: BopsOptions[] = bopsOptions.sort((a, b) => a.name.localeCompare(b.name));

// Cover Sheet option ID for filtering
export const COVER_SHEET_OPTION_ID = 3335;

// Function to get bopsOptions with feature flag filtering
export const getFilteredBopsOptions = (isCoverSheetEnabled: boolean): BopsOptions[] => {
  return isCoverSheetEnabled ? bopsOptions : bopsOptions.filter((option) => option.id !== COVER_SHEET_OPTION_ID);
};

// Function to get sorted bopsOptions with feature flag filtering
export const getFilteredSortedBopsOptions = (isCoverSheetEnabled: boolean): BopsOptions[] => {
  return getFilteredBopsOptions(isCoverSheetEnabled).sort((a, b) => a.name.localeCompare(b.name));
};
